// utils/coords.js
import proj4 from 'proj4';
import axios from 'axios'

proj4.defs('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');

const etrs89UtmToWgs84 = (x, y) => {
  const [lon, lat] = proj4('EPSG:25832', 'EPSG:4326', [x, y]);
  return { lat, lon };
};

const getCoordinatesFromAdress = async (href) => {
  return new Promise((resolve) => {
    axios.get(href)
    .then((response) => {
      const x = response.data.husnummer.adgangspunkt.geometri.coordinates[0];
      const y = response.data.husnummer.adgangspunkt.geometri.coordinates[1];
      const { lat, lon } = etrs89UtmToWgs84(x, y);

      resolve({lat, lng: lon});
    })
    .catch(function (error) {
      console.log(error);
    });
  });
};

export {
  etrs89UtmToWgs84,
  getCoordinatesFromAdress,
}